<field-text-readonly *ngIf="field.readonly; else editable" [field]="field"></field-text-readonly>
<ng-template #editable>
  <field-text-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-text-single>
  <field-text-multiple *ngIf="field.multiple" [formGroup]="formGroup" [field]="field"></field-text-multiple>
</ng-template>
